import React, { useMemo, useState, useEffect } from "react";
import { MaterialReactTable } from "material-react-table";
import { Select, MenuItem, Button, Box } from "@mui/material";
import { getDisplayRecords, updateRecord } from "../../pages/approver/approverKpi";

const ApproverTable = ({ data }) => {
  const [tableData, setTableData] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const useDetailsToken = localStorage.getItem("token");

  useEffect(() => {
    if (data && Array.isArray(data)) {
      setTableData(
        data.map((item) => ({
          ...item,
          initialStatus: item.status,
        }))
      );
    }
  }, [data]);

  const columns = useMemo(() => {
    if (!tableData || tableData.length === 0) return [];

    return Object.keys(tableData[0])
      .filter((key) => key !== "initialStatus")
      .map((key) => {
        if (key === "status") {
          return {
            accessorKey: key,
            header: "Status",
            size: 150,
            Cell: ({ row }) => {
              const currentStatus = row.original.status;
              const isDisabled =
                row.original.initialStatus === "Approved" ||
                (submitted &&
                  (currentStatus === "Approved" ||
                    currentStatus === "Rejected"));

              return (
                <Select
                  size="small"
                  value={currentStatus || "Pending"}
                  disabled={isDisabled}
                  onChange={(e) => {
                    const newStatus = e.target.value;
                    setTableData((prev) =>
                      prev.map((item, i) =>
                        i === row.index ? { ...item, status: newStatus } : item
                      )
                    );
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      padding: "4px 8px",
                      fontSize: "0.8rem",
                    },
                  }}
                >
                  <MenuItem value="Approved">Approve</MenuItem>
                  <MenuItem value="Rejected">Reject</MenuItem>
                  <MenuItem value="Pending">Pending</MenuItem>
                </Select>
              );
            },
          };
        }

        return {
          accessorKey: key,
          header: key.replace(/_/g, " ").toUpperCase(),
          size: 200,
        };
      });
  }, [tableData, submitted]);

  const handleSubmit = async () => {
    setSubmitted(true);
    const editedRows = tableData.filter(
      (item) => item.status !== item.initialStatus
    );

    if (editedRows.length === 0) {
      // console.log("No changes to submit.");
      return;
    }

    try {
      const results = await updateRecord(editedRows, useDetailsToken);
      // console.log("Update results:", results);
      const refreshed = await getDisplayRecords();
      setTableData(
        refreshed.map((item) => ({
          ...item,
          initialStatus: item.status,
        }))
      );
      setSubmitted(false);
    } catch (error) {
      console.error("Error updating records:", error);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",     // centers horizontally
        justifyContent: "center", // centers vertically
        justifyItems: "center",
        minHeight: "70vh",       // full screen height
        p: 2,
      }}
    >
      <Box
        sx={{
          width: "80%",           // table wrapper
          maxWidth: "900px",      // limit max size
        }}
      >
        <MaterialReactTable
          columns={columns}
          data={tableData}
          density="compact"
          muiTablePaperProps={{
            elevation: 0,
            sx: {
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              overflow: "hidden",
            },
          }}
          muiTableBodyCellProps={{
            sx: {
              whiteSpace: "normal",
              overflowWrap: "break-word",
              fontSize: "0.8rem",
              padding: "8px",
            },
          }}
          muiTableHeadCellProps={{
            sx: {
              fontSize: "0.8rem",
              padding: "8px",
            },
          }}
        />
        <div className="flex items-center justify-center w-full">
          <button
            onClick={handleSubmit}
            className="bg-blue-500 px-4 py-1 font-semibold text-white rounded-md mt-4"
          >
            Submit
          </button>
        </div>
      </Box>
    </Box>
  );

};

export default ApproverTable;
